import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import SiteNavAMobileLevelD from '../SiteNavAMobileLevelD';
import classes from './SiteNavAMobileLevelCItem.module.scss';

const SiteNavAMobileLevelCItem = (props) => {
  const {
    href,
    id,
    heading,
    items = [],
    onLevelCItemClick,
    isExpanded,
  } = props;

  const arrowClassName = isExpanded ? classes.arrowButtonOpen : classes.arrowButtonClosed;

  const renderLink = (
    <div className={classes.container}>
      <a
        aria-label={heading}
        className={classes.menu}
        href={href}
      >
        <div className={classes.wrapper}>
          <div className={classes.menuItemContainer}>
            <div
              className={classes.heading}
              dangerouslySetInnerHTML={{ __html: heading }}
            />
          </div>
        </div>
      </a>
    </div>
  );

  const renderButton = (
    <div className={classes.container}>
      <button
        className={classes.menu}
        onClick={(e) => { onLevelCItemClick(id, e); }}
        aria-label={heading}
        type='button'
      >
        <div className={classes.wrapper}>
          <div className={classes.menuItemContainer}>
            <div
              className={classes.heading}
              dangerouslySetInnerHTML={{ __html: heading }}
            />
            <div className={classes.arrowWrapper}>
              <div className={arrowClassName}>
                <FontIcon title={`Show ${heading} Items`} icon='far fa-angle-down' />
              </div>
            </div>
          </div>
        </div>
      </button>
      {isExpanded &&
        <SiteNavAMobileLevelD {...props} />}
    </div>
  );

  return (
    items.length > 0 ? renderButton : renderLink
  );
};

SiteNavAMobileLevelCItem.propTypes = {
  heading: PropTypes.string,
  href: PropTypes.string,
  onLevelCItemClick: PropTypes.func,
  isExpanded: PropTypes.bool,
  id: PropTypes.string,
  items: PropTypes.array,
};

export default SiteNavAMobileLevelCItem;
